import {Sequence} from 'components/Sequence';
import * as navigation from 'Navigation';

class HRTemplateTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Design HR Template',
      closeable: false,
      preferenceKey: navigation.PREFERENCE_KEY_IGNORE,
    };
  }
  sequence(): Sequence {
    return this.get('sequence');
  }
}
export default HRTemplateTabState;
